import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      '& $headerTitle': {
        textAlign: 'left',
      },
    },
    headerTitle: {},
    subtitle: {
      fontSize: 20,
      lineHeight: 1.5,
      textAlign: 'left',
      maxWidth: 510,
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    cardContainer: {
      width: '100%',
    },
    subscriptionInfoContainer: {
      [theme.breakpoints.up('md')]: {
        width: `calc(57% - ${SMALL_MARGIN / 2}px)`,
      },
    },
    additionalInfoContainer: {
      [theme.breakpoints.up('md')]: {
        width: `calc(43% - ${SMALL_MARGIN / 2}px)`,
      },
    },
    cardSubtitle: {
      color: colorsPalette.gray,
      fontSize: 18,
      lineHeight: 1.5,
      marginTop: MIDDLE_MARGIN,
      marginBottom: MIDDLE_MARGIN,
    },
    subscrInfoList: {
      listStyle: 'none',
      margin: '0 0 43px',
      padding: 0,
    },
    subsctListItem: {
      fontSize: 18,
      lineHeight: 1.4,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      padding: `${SMALL_MARGIN}px 0`,
      marginBottom: SMALL_MARGIN,
      borderBottom: `1px solid ${fade(colorsPalette.white, 0.33)}`,
    },
    subsctListItemTitle: {
      fontSize: 18,
      lineHeight: '24px',
      width: '50%',
      [theme.breakpoints.up('md')]: {
        width: `calc(60% - ${SMALL_MARGIN}px)`,
        paddingLeft: 24,
      },
    },
    subscrItem: {
      color: colorsPalette.gray,
      fontWeight: 'bold',
      fontSize: 20,
      lineHeight: 1.4,
      width: 'calc(50% - 10px)',
      [theme.breakpoints.up('md')]: {
        width: '40%',
        paddingRight: 24,
      },
    },
    lightCard: {
      padding: `40px 24px`,
      borderRadius: 10,
      marginBottom: MIDDLE_MARGIN,
      '& $cardSubtitle': {
        marginTop: 9,
      },
      [theme.breakpoints.up('md')]: {
        padding: 56,
      },
    },
    darkCard: {
      padding: `40px 24px`,
      borderRadius: 10,
      boxShadow: `0px 3px 6px ${fade(colorsPalette.blackPure, 0.4)}`,
      background: theme.palette.secondary.light,
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        padding: 56,
      },
    },
    accountInfo: {
      color: colorsPalette.gray,
      fontSize: 18,
      lineHeight: 1.5,
      [theme.breakpoints.down('sm')]: {
        marginBottom: MIDDLE_MARGIN,
      },
    },
    accountLink: {
      color: colorsPalette.violet,
    },
    button: {
      '&:hover': {
        '& $buttonIcon': {
          color: `${fade(colorsPalette.blackPure, 0.87)}`,
        },
      },
    },
    linkedInIcon: {
      backgroundColor: colorsPalette.white,
      borderRadius: 3,
    },
    buttonIcon: {
      width: 16,
      height: 16,
      minWidth: 16,
      marginRight: 9,
    },
  }),
);

export default useStyles;
